import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel"]
  static values = { when: Array }

  connect() {
    this.update()
  }

  update() {
    const checked = this.element.querySelector("input[type=radio]:checked")
    const revealed = Boolean(checked) && this.whenValue.includes(checked.value)

    this.panelTargets.forEach((panel) => { panel.hidden = !revealed })
  }
}
